import React from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

interface DraggableListProps<T> {
  items: T[];
  onDragEnd: (result: any) => void;
  getKey: (item: T) => string;
  renderItem: (item: T, index: number, provided: any) => React.ReactNode;
  droppableId: string;
}

const DraggableList = <T,>({ items, onDragEnd, getKey, renderItem, droppableId }: DraggableListProps<T>) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId={droppableId} direction="vertical">
      {provided => (
        <div ref={provided.innerRef} {...provided.droppableProps} className="tabsFlex column">
          {items.map((item, index) => (
            <Draggable key={getKey(item)} draggableId={getKey(item)} index={index}>
              {prov => renderItem(item, index, prov)}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

export default DraggableList;
